import styled from 'styled-components'

const BlockActionIconUi = styled.span`
  font-size: 12px;
  padding: 0 5px;
  cursor: pointer;
`

export default BlockActionIconUi
